import { render, staticRenderFns } from "./ModalBranches.vue?vue&type=template&id=56d72dc1&lang=pug&"
import script from "./ModalBranches.vue?vue&type=script&lang=js&"
export * from "./ModalBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports